import {styled} from '../../styled-components';

/**
 * Container for dialog content.
 */
export const DialogContentStyle = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    padding: ${props => props.theme.spacing.units(4)};
    font-family: ${props => props.theme.typography.fontFamily};
    background: ${props => props.theme.color.primary.light};
    color: ${props => props.theme.color.text};
`;

DialogContentStyle.displayName = 'DialogContentStyle';
